export default "__VITE_ASSET__B4kh6rkG__"